
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shop/list/[shopSysNo]",
      function () {
        return require("private-next-pages/shop/list/[shopSysNo].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/shop/list/[shopSysNo]"])
      });
    }
  